export const listVehicleBidTypes = {
    POST_REQUEST: 'LISTVEHICLE_BID_POST_REQUEST',
    POST_SUCCESS: 'LISTVEHICLE_BID_POST_SUCCESS',
    POST_FAILURE: 'LISTVEHICLE_BID_POST_FAILURE',
};
